var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"page-row",style:(_vm.style)},_vm.$listeners),[_c(_vm.template,_vm._b({tag:"component"},'component',_vm.row,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }